<template>
  <div>
    <div class="item-line">活动提报信息</div>
    <div class="budgetBox bodyBox">
      <a-form-model ref="signUpForm" class="UniformCss" :inline="true" :model="data" :rules="rules" :label-col="{ span: 8, style: { width: '100px' } }">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="经理部" class="sign-tiem">
                <!-- <a-select v-model="data.regionId" placeholder="经理部" @change="selectChangeJingLiBu">
                  <a-select-option v-for="item in sectorList"
                  :key="item.sectorId"  
                  :value="item.sectorId" >{{item.sectorName}}</a-select-option>
              </a-select> -->
              <a-input v-model="managementDeptName" disabled placeholder=""/>
            </a-form-model-item>
          </a-col>
          <el-col :span="6" v-show="false">
            <a-form-model-item label="经销商" class="sign-tiem widthHuo" :label-col="{span:3}">
              <a-input v-model="data.dealerName" disabled placeholder="请输入经销商"/>
            </a-form-model-item>
          </el-col>
          <el-col :span="6">
            <a-form-model-item label="经销商" class="sign-tiem widthHuo" :label-col="{span:3}">
              <a-input v-model="data.dealerShortName" disabled placeholder="请输入经销商"/>
            </a-form-model-item>
          </el-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="申报月份" prop="actMonth" :rules="[{ required: true, message: '请选择申报月份!', trigger: 'change' }]" class="sign-tiem">
              <a-month-picker
                format="YYYY-MM"
                valueFormat="YYYY-MM"
                v-model="data.actMonth"
                :disabled-date="disabledMonth"
                placeholder="选择月份"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="18">
            <a-form-model-item label="活动提报名称" :label-col="{ span: 3 }" :rules="[{ required: true, message: '请输入!', trigger: 'blur' }]" class="sign-tiem widthHuo">
              <a-input v-model="data.planApplyName" :disabled="disabledEdit" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="活动提报编码" class="sign-tiem">
              <a-input v-model="data.planApplyCode" :disabled="true" placeholder="" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="提报类型" class="sign-tiem">
              <a-select v-model="data.itemType" :disabled="true">
                <a-select-option v-for="(tiem, i) in SelectLists.TypesOfPresentation" :key="i" :value="tiem.code" >{{tiem.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="提报时间" class="sign-tiem">
              <a-input v-model="data.applyTime" :disabled="true" />
            </a-form-model-item>
          </a-col> -->

          <!-- lr0033 -->

          <a-col :span="6"> 
            <a-form-model-item label="计划开始日期" class="act-item" prop="planStartTime" >
              <el-date-picker
                style="width:100%"
                v-model="data.planStartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
               >
            </el-date-picker>      
            </a-form-model-item>
          </a-col>

<!-- 
          <a-col :span="6"> 
            <a-form-model-item label="计划开始日期" class="act-item" prop="planStartTime" :rules="[{ required: true, message: '请选择开始时间!', trigger: 'change' }]">
              <el-date-picker
                style="width:100%"
                v-model="data.planStartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期（不得早于当前日期）"
                @change="data.planEndTime && (data.planEndTime = '')"
              />
            </a-form-model-item>
          </a-col> -->

          <a-col :span="6">
            <a-form-model-item label="计划结束日期" class="sign-tiem" prop="planEndTime" >
                <el-date-picker
                  style="width:100%"
                  v-model="data.planEndTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                />
            </a-form-model-item>
          </a-col>
          <!-- 弃用 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="执行数量" class="sign-tiem" prop="executeNums" :rules="[{ required: true, message: '请选择!', trigger: 'blur' }]">
              <a-input v-model="data.executeNums" placeholder="月/天/场/次/项/人" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="活动预算(元)" class="sign-tiem" prop="actBudget" :rules="[{ required: true, message: '请选择!', trigger: 'blur' }]">
              <a-input v-model="data.actBudget" maxlength="13" oninput="value=value.replace(/\D/g, '')" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="品系" prop="strainsArr" :rules="[{ required: true, message: '请选择!', trigger: 'blur' }]">
              <a-select v-model="data.strainsArr" multiple placeholder="请选择品系" :collapse-tags="true" @change="selectChange">
                <a-select-option key="0" label="全部" value="0" />
                <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode" :label="item.strains" :value="item.strainsCode" />
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="提报状态" class="sign-tiem">
              <a-select v-model="data.applyStatus" :disabled="true">
                <a-select-option v-for="(tiem, i) in SelectLists.ActPlanApplyStatus" :key="i" :value="tiem.code">{{tiem.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="集客目标" class="sign-tiem">
              <a-input v-model="data.customerTarget" :disabled="true" placeholder="" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="订单目标" class="sign-tiem">
              <a-input v-model="data.orderTarget" :disabled="true" placeholder="" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <component :is="getFormByActivity(activity.threeLevelName)" ref="activityForm" :activity="activity" :formData="data"></component>
        <a-row>
          <a-col :span="12" style="height: auto">
            <a-form-model-item label="计划方案" v-if="(typeof (this.data.planApplyCode) !== 'undefined')" class="sign-tiem" :label-col="{ span: 3 }">
              <el-upload
                ref="uploadFile"
                class="upload-demo"
                action=""
                :before-upload="beforeUpload"
                :on-preview="onPreviewFun"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :http-request="uploadHttpRequest"
                :auto-upload="false"
                :file-list="fileList"
              >
                <el-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" type="primary">选择文件</el-button>
                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload()">上传到服务器</el-button> -->
                <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div>
              </el-upload>
            </a-form-model-item>
            <a-form-model-item label="计划方案" v-if="(typeof (this.data.planApplyCode) === 'undefined')" class="sign-tiem" :label-col="{ span: 3 }">
              <el-button @click="uploadClick" icon="el-icon-circle-plus-outline" type="primary" size="small">选择文件</el-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    
    </div>
  </div>
</template>
<script>
import { getActById, queryCarStrainsInfo } from '@/api/activity.js'
import { getManagementDept4Dealer } from '@/api/base-data'
import { deleteFile, uploadPlanFiles } from '@/api/actPlan'
import { http } from '@/api/activityCheck'
// import upload from '@/components/files/upload.vue'
import moment from 'moment';
import form1 from './activityForm/components/form1.vue';
import form2 from './activityForm/components/form2.vue';
import form3 from './activityForm/components/form3.vue';
import form4 from './activityForm/components/form4.vue';
import form5 from './activityForm/components/form5.vue';
import form7 from './activityForm/components/form7.vue';
const activityFormMap = {
        // "form1": ["直播（短视频）", "网红传播", "试驾推介会", "婚车", "赞助", "交车仪式", "客户联谊", "意向合作伙伴来柳", "意向网络座谈", "渠道培训"],
        // "form2": ["产品展示"],
        // "form3": ["客户拜访（座谈）", "双节拜访", "客户来柳参观", "行业客户专项拜访"],
        // "form4": ["平台运营"],
        // "form5": ["事件慰问", "望子乘龙", "乘龙助学", "卡友体检", "公益项目"],
        // "form7": ["广告", "发布品鉴会（答谢会）"]
        "form1": ["直播（短视频）", "网红传播", "数字营销-其它", "客户拜访（座谈）", "试驾推介会", "集中交车", "客户联谊", "窝子活动-其它", "品鉴会/答谢会", "婚车服务", "生态赞助", "交车仪式","专项推广-其它", "意向合作伙伴来柳", "意向网络座谈", "渠道培训", "渠道开发-其它"],
        "form2": ["产品展示","区域车展"],
        "form3": ["双节拜访", "协会入会", "客户来柳参观", "行业客户专项拜访", "行业客户开发-其它", "上门拜访" ,"客户运营-其他"],
        "form4": ["平台运营"],
        "form5": ["事件慰问", "望子乘龙", "乘龙助学", "销服联动", "卡友体检", "公益项目", "关怀基金-其它"],
        "form7": ["广告投放"]
    }

export default {
  name: 'RegisterInformation',
  // props: ['data', 'activity', 'fileList', 'disabledEdit'],
  components:{ form1, form2, form3, form4, form5, form7},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    activity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabledEdit: {
      type: Boolean,
      default: true
    }
  },
  // components: { upload },
  data() {
    return {
      rules: {
        planStartTime: [{ required: true, message: '请选择计划开始日期', trigger: 'blur' }],
        planEndTime: [{ required: true, message: '请选择计划结束日期', trigger: 'blur' },{
          validator: (rule, value, callback) => {
            if (this.data.planStartTime && value) {
              const start = new Date(this.data.planStartTime);
              const end = new Date(value);
              if (end < start) {
                callback(new Error('结束日期不得早于开始日期'));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        executeNums: [{ required: true, message: '请填写执行数量(月/天/场/次/项/人)', trigger: 'blur' }],
        actBudget: [{ required: true, message: '请填写活动预算', trigger: 'blur' }],
        strainname: [{ required: true, message: '请选择品系', trigger: 'blur' }]
      },
      carStrainsDS: [],
      SelectLists: {},
      officeTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
      form:{
        activityType: ''
      },
      invoicingTime:'',
      sectorList: [],
      managementDeptName: '',
      selectedDate: null,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.data.planStartTime) {
            const startTime = new Date(this.data.planStartTime).getTime();
            return time.getTime() < startTime;
          }
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  computed: {
    defaultMonth() {
      const currentDate = new Date() // 获取当前日期
      const currentYear = currentDate.getFullYear() // 获取当前年份
      const currentMonth = currentDate.getMonth() // 获取当前月份（0-11）
      if (this.data.itemType === '0' && currentMonth === 11) {
        return new Date(currentYear + 1, 0, 1)
      } else {
        return new Date(currentYear, 0, 1)
      }
    }
  },
  watch: {
    data() {
      console.log(this.data,'-----watch监听的数据--data');
      if (this.data.actscheme) {
        // 提报附件回显
        const arr = []
        JSON.parse(this.data.actscheme).forEach(v => {
          v.uid = v.path + '/' + v.name
          arr.push(v)
        })
        this.$refs.uploadFile.uploadFiles = arr
      }
    },
    activity() {
      // 获取品系
      this.getCarStrains()
      // 获取经理部
      this.getSectorList()
      this.actMonthChange()
    },
    'data.planStartTime'(newVal) {
      if (newVal && this.data.planEndTime) {
        const start = new Date(newVal);
        const end = new Date(this.data.planEndTime);
        if (end < start) {
          this.data.planEndTime = '';
        }
      }
    }
  },
  created() {
    // 获取品系
    // this.getCarStrains()
    // 下拉框获取
    this.SelectListsFun()
    // 获取经理部
    this.getSectorList()
    this.actMonthChange()
    console.log(this.data,"this.Data11111")

  },
  methods: {
    disabledMonth(current) {
      
      const currentDate = moment(); // 获取当前日期
      const currentYear = currentDate.year(); // 获取当前年份
      const currentMonth = currentDate.month(); // 获取当前月份（0-11）

      const selectedYear = current.year(); // 获取选择的年份
      const selectedMonth = current.month(); // 获取选择的月份

      // console.log(currentYear,'---currentYear----');
      // console.log(currentMonth,'---currentMonth----');
      // console.log(selectedYear,'---selectedYear----');
      // console.log(selectedMonth,'---selectedMonth----');

      if (this.data.itemType === '1') {
        // 追加，如果选择的年份小于当前年份，或者选择的年份等于当前年份但月份小于当前月份，则禁用
        return selectedYear < currentYear || (selectedYear === currentYear && selectedMonth < currentMonth);
      } else {
        // 提报，如果选择的年份小于当前年份，或者选择的年份等于当前年份但月份小于等于当前月份，则禁用
        return selectedYear < currentYear || (selectedYear === currentYear && selectedMonth <= currentMonth);
      }
    },
    planStartDisabled(current) {
      // 确保 current 是一个 moment 对象
      const currentMoment = moment(current);
      const activityStart = moment(this.activity.planStartTime);
      const activityEnd = moment(this.activity.planEndTime);
      const now = moment();

      // 如果活动开始时间在当前时间之后，则禁用从当前时间往回一天到活动开始时间之间的所有日期
      if (activityStart.isAfter(now)) {
        return currentMoment.isBefore(activityStart.clone().subtract(1, 'day'));
      }
      // 如果活动开始时间在当前时间或之前，则禁用从当前时间往回一天到当前时间之间的所有日期
      return currentMoment.isBefore(now.clone().subtract(1, 'day')) || currentMoment.isAfter(activityEnd);
    },
    planEndDisabled(current) {
      // 将字符串日期转换为 Date 对象
      const start = new Date(this.data.planStartTime);
      const end = new Date(this.activity.planEndTime);
      const now = new Date();

      // 禁用从当前时间往回一天到活动开始时间之间的所有日期
      if (start > now) {
        return current < new Date(now.setDate(now.getDate() - 1)) || current > end;
      }

      // 禁用从活动开始时间往回一天到活动开始时间之间的所有日期
      return current < new Date(start.setDate(start.getDate() - 1)) || current > end;
    },
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['ActPlanApplyStatus', 'TypesOfPresentation']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
          this.filteredStrains()
        }
      })
    },
    // 获取经理部
    getSectorList() {
      getManagementDept4Dealer().then(res => {
        if (res.code === 1 && res.data) {
          this.data.regionId = res.data.managementDeptId
          this.data.regionName = res.data.managementDeptName
          this.managementDeptName = res.data.managementDeptName
          // this.sectorList = res.data
        }
      })
    },
    // 过滤品系
    filteredStrains() {
      if (this.activity.strainsCarCode) {
        const stringArray = this.activity.strainsCarCode.split(',')
        const arr = []
        stringArray.forEach(item => {
          const itemArr = item.split('-')
          arr.push(itemArr[0])
        })
        this.carStrainsDS = this.carStrainsDS.filter(value => arr.includes(value.strainsCode))
      }
    },
    selectChange(val) {
      var nameArr = []
      // 全部
      var res = val.find(i => i === '0')
      if (res) {
        const strainsArr = []
        this.carStrainsDS.forEach(obj => {
          nameArr.push(obj.strains)
          strainsArr.push(obj.strainsCode)
        })
        this.$emit('setStrainsArr', strainsArr)
      } else {
        val.forEach(item => {
          const temp = this.carStrainsDS.find(i => i.strainsCode == item).strains
          nameArr.push(temp)
        })
      }
      this.data.strainsName = nameArr.toString()
    },
    // 点击文件
    async onPreviewFun(e) {
      let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
      console.log(pathUrl + e.url,'---e-----');
      if (e.url) {
        // 已上传文件
        // const fileName = e.name
        // const suffix = fileName.substring(fileName.lastIndexOf('.') + 1)

        // if (this.officeTypeList.includes(suffix)) {
        //   // office打开新窗口
        //   const routeData = this.$router.resolve({
        //     query: { name: e.name, url: pathUrl + e.url },
        //     path: '/previewFile'
        //   })
        //   window.open(routeData.href, '_blank')
        // } else {
          // 其它类型直接打开
          window.open(pathUrl + e.url, '_blank')
        // }
      } else {
        // 未上传文件
        this.exportExcelData(e.raw, e.name)
      }
    },
    // 二进制流下载 res 流 name 文件名
    exportExcelData(res, name) {
      // 拿到流 设置格式
      var blob = new Blob([res], { type: 'application/msword,charset=utf-8' })
      // 兼容ie
      if (window.navigator.msSaveOrOpenBlob) {
        // IE 下载文件
        navigator.msSaveBlob(blob, NamedNodeMap)
      } else {
        // 创建a标签
        let ele = document.createElement('a')
        // 通过URL.createObjectURL(blob)可以获取当前文件的一个内存URL 设置下载文件的url地址
        ele.setAttribute('href', URL.createObjectURL(blob))
        // 给a标签设置下载按钮
        ele.setAttribute('download', name)
        // 点击下载开始
        ele.click()
        // 收尾
        ele = null
      }
    },
    // 图片文件获取方法
    downloadFiles(obj) {
      return new Promise(resolve => {
        const path = obj.path
        const fileName = obj.name
        http.download({ path, fileName }).then(blob => {
          resolve(window.URL.createObjectURL(blob))
        })
      })
    },
    submitUpload() {
      this.$refs.uploadFile.submit()
    },
    uploadHttpRequest(param) {
      if (typeof (this.data.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再上传文件')
        return
      }
      const formData = new FormData()
      const data = {
        type: 'actPlanApply',
        code: this.data.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    beforeUpload(file) {
      // 文件大小限制为20M
      const fileLimit = file.size / 1024 / 1024 < 20
      if (!fileLimit) {
        this.$message.warning('上传文件大小不超过40M！')
      }
      // 返回判断条件,false停止上传
      return fileLimit
    },
    
    //  判断 有没有   this.form.planApplyCode
    uploadClick() {
      if (typeof (this.data.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再申请表扫描件')
        this.fileList = []
        return
      }
    },
    // 上传计划方案
    handleChange(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 20) {
        this.$message.error('文件大小限制20M!')
        fileList.pop()
        return
      }
      const flag = this.fileList.find(item => item.name === file.name)
      if (flag) {
        this.$message.error('文件名重复，请修改文件名后重新上传!')
        fileList.pop()
        return
      }
      if (typeof (this.data.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再上传文件')
        this.fileList = []
        return
      }
      this.$emit('update:fileList', fileList)
      this.$refs.uploadFile.submit()
    },
    handleRemove(file, fileList) {
      if (file.status === '1') {
        const params = {
          name: file.name,
          code: this.data.planApplyCode,
          module: 'actPlanApply'
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.$emit('update:fileList', fileList)
    },
    beforeRemove() {
    },
    // 填写申请月份
    actMonthChange() {
      // actMonthChange(val) {
      // var remindTime = val // 自己选择的时间
      // var str = remindTime.toString() // toString
      // str = str.replace('/-/g', '/') // 去空格字符等
      // var oldTime = new Date(str).getTime() // 装date
      // this.data.actMonth = this.timestampToTime(oldTime, 1)
      // if (!oldTime >= new Date().setMonth(new Date().getMonth() - this.$route.params.type) - 8.64e7) {
      //   this.data.actMonth = ''
      //   this.$message.error(this.$route.params.type == 1 ? '请选择大于等于本月份' : '提报类型为正常,请选择大于本月份，追加才可提报本月活动')
      // }
      
      const currentDate = new Date();
      let date = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1);
      this.data.actMonth = date
      console.log(date,'0000000000');
      
    },
    // 格式化时间
    timestampToTime(cjsj, type) {
      var date = new Date(cjsj) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '/'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      var D = date.getDate()
      // var h = date.getHours() + ':'
      // var m = date.getMinutes() + ':'
      // var s = date.getSeconds()
      if (type == 1) {
        return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      }
      return Y + M + D
    },
    // 获取活动详情
    getActById(id) {
      var data = {
        actplanid: id
      }
      getActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(activityType) {
      console.log(activityType,'---activityType----');
      
      // 遍历映射对象
      for (const form in activityFormMap) {
          // 检查活动类型是否在当前表单类型的数组中
          if (activityFormMap[form].includes(activityType)) {
          return form;
          }
      }
      // 如果没有找到对应的表单，返回"未知表单"
      return "form1";
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-upload__input {
  display: none !important;
}
/deep/ .el-input__inner {
  height: 32px!important;
}
.item-line {
  padding: 0px 20px;
  width: 100%;
  margin: 0;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.usereq {
  .a-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .a-select.a-input--small .a-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 20px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
  .dialog-footer {
    width: 100px;
  }  
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  width: 100%;
}
.widthHuo{
  ::v-deep .ant-form-item-label{
    width:100px !important
  }
}

</style>
